/**
 * Add/remove document classes based on device.
 *
 */
 (function (drupalSettings){
  "use strict";

  Drupal.behaviors.documentClasses = {
    attach: function () {

      let classes = {
        add: [
        drupalSettings.env.isTouch ? 'touch' : 'no-touch',
        drupalSettings.env.os ? 'os-' + drupalSettings.env.os : 'os-unknown'
        ],
        remove: ['preload']
      };

      DOMTokenList.prototype.add.apply(document.documentElement.classList, classes.add);
      DOMTokenList.prototype.remove.apply(document.documentElement.classList, classes.remove);

    }
  };
})(drupalSettings);
